import React, { useContext } from "react";

import { Notification } from "@magnetic/notification";

import { ApiError, isApiError } from "src/core/apiError";
import { DataProviderContext } from "src/core/provider/dataProvider";
import { ErrorCode } from "src/gen/schema/syncfollow/syncfollow";
import { CandidateMode } from "src/utils/api/configD";

interface ErrorNotificationProps {
  readonly error?: ApiError;
  readonly msg?: string | React.ReactNode;
  readonly onClose?: () => void;
}

const getErrorText = (error: ApiError | undefined): string | undefined => {
  if (!error) return undefined;
  if (isApiError(error)) return error.getMessage();
  if (typeof (error as { message?: string }).message === "string") {
    return (error as { message: string }).message;
  }
  return String(error);
};

export const ErrorNotification = ({
  error,
  msg,
  onClose
}: ErrorNotificationProps) => {
  if (error || msg) {
    const text = error ? getErrorText(error) : msg;
    return (
      <Notification
        status="negative"
        onClose={onClose}
        data-qa="error-notification"
      >
        {text}
      </Notification>
    );
  }
  return null;
};

/**
 * Error for managing Sextant specific errors
 * @constructor
 */
export const SextantErrorNotification = ({
  error,
  msg
}: ErrorNotificationProps) => {
  const { mode } = useContext(DataProviderContext);
  if (error) {
    if (
      mode === CandidateMode.Edit &&
      error.getSyncFollowErrorCode() === ErrorCode.ERR_FORBIDDEN
    ) {
      return null;
    }
  }
  return <ErrorNotification error={error} msg={msg} />;
};
